export default __webpack_public_path__ + "32ffb0f10228b101f86aac3136ecc64a.svg";